import { render, staticRenderFns } from "./date-time-picker-format-editor.vue?vue&type=template&id=e86b0636&scoped=true"
import script from "./date-time-picker-format-editor.vue?vue&type=script&lang=js"
export * from "./date-time-picker-format-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86b0636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e86b0636')) {
      api.createRecord('e86b0636', component.options)
    } else {
      api.reload('e86b0636', component.options)
    }
    module.hot.accept("./date-time-picker-format-editor.vue?vue&type=template&id=e86b0636&scoped=true", function () {
      api.rerender('e86b0636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-date-time-picker/date-time-picker-format-editor.vue"
export default component.exports